var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46699 15.6013H5.33366V17.468H16.5337V2.53464H5.33366V4.4013H3.46699V1.6013C3.46699 1.08584 3.88486 0.667969 4.40033 0.667969H17.467C17.9825 0.667969 18.4003 1.08584 18.4003 1.6013V18.4013C18.4003 18.9168 17.9825 19.3346 17.467 19.3346H4.40033C3.88486 19.3346 3.46699 18.9168 3.46699 18.4013V15.6013ZM5.33366 9.06797H11.867V10.9346H5.33366V13.7346L0.666992 10.0013L5.33366 6.26797V9.06797Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutblack);
export default __webpack_public_path__ + "static/media/Logoutblack.0187bae2f014e3d329bef53a28895d58.svg";
export { ForwardRef as ReactComponent };